import dayjs from "dayjs";
import { array, date, object } from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  purchaseInvoicePayments: [],
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().required("Harus diisi"),
  outletChartOfAccount: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  purchaseInvoicePayments: array()
    .of(object().shape({})) // Ensures each item is an object (can be expanded with more validation)
    .min(1, "Harus memiliki setidaknya satu produk"), // ✅ Ensures at least 1 item
});
